import { atom } from 'jotai';

import { AddAsWatchersPopupState } from './AddAsWatchersPopup.types';

export const addAsWatcherPopupState = atom<AddAsWatchersPopupState>({
    usersWithoutAccess: [],
});
